import React from 'react';
import { Text } from 'react-native';

const AppText = ({
  style, children, size, ...props
}) => <Text style={[{ fontFamily: size === 'bold' ? 'MBold' : (size === 'medium' ? 'MMedium' : 'MRegular') }, style]} {...props}>{children}</Text>;

export default AppText;
